<template>
    <div>
        <!-- role. -->
        <!-- {{ this.$store.state.permit.RulesUser.roles }} -->
        <staff-profile v-if="this.$store.state.permit.RulesUser.roles.includes('staff') || this.$store.state.permit.RulesUser.roles.includes('faculty') || this.$store.state.permit.RulesUser.roles.includes('pc_lecturers')"></staff-profile>
        <student-profile v-if="this.$store.state.permit.RulesUser.roles.includes('student')"></student-profile>
    </div>
</template>

<script>
    import store from "@/store/index";
        import staffProfile from "./UserCard";
        import studentProfile from "./StudentCard";
    export default {
        components: {
            staffProfile,
            studentProfile,
        },
        data(){
            return{}
        }
    }
</script>

<style lang="scss" scoped></style>